import { useGetFileUploadData } from "@/components/upload/hooks/useGetFileUploadData"
import type { SignedUrl } from "@/graphql/codegen/graphql"
import { ReferenceTableName } from "@/graphql/codegen/graphql"

export interface UseInvoiceDocumentsReturn {
  documents: SignedUrl[]
  isFetching: boolean
  refetch: (immediate?: boolean) => void
}

export const useInvoiceDocuments = (invoiceId: string | undefined): UseInvoiceDocumentsReturn => {
  const { fileList, fileFetching, refetchFileUploadData } = useGetFileUploadData({
    referenceId: invoiceId,
    referenceTableName: ReferenceTableName.Invoice,
    pause: !invoiceId,
  })

  const documents = fileList.filter((signedUrl) => !signedUrl.file?.isArchived)

  return { documents, isFetching: fileFetching, refetch: refetchFileUploadData }
}
